/* Stable offer IDs connect photographs, benefits and the exact Shopify variant.
   Shopify availability and price determine whether an offer can be purchased.
   Customer-facing properties describe benefits;
   only server-side product/app configuration grants discounts or entitlements. */
(() => {
  const initGallery = root => {
    const gallery = root.querySelector('[data-product-gallery]');
    if (!gallery) return null;
    const $ = selector => gallery.querySelector(selector);
    const $$ = selector => [...gallery.querySelectorAll(selector)];
    const manifest = JSON.parse($('[data-gallery-contract]').textContent);
    const mainImage = $('[data-gallery-image]');
    const openLink = $('[data-gallery-open]');
    const thumbnails = $$('[data-gallery-index]');
    const strip = $('[data-gallery-thumbs]');
    const dialog = $('[data-gallery-dialog]');
    const fullImage = $('[data-gallery-full-image]');
    const zoomArea = $('[data-gallery-zoom-area]');
    const zoomButton = $('[data-gallery-zoom]');
    let frames = [];
    let offerKey;
    let index = 0;
    let touchStart;
    let ignoreOpen = false;

    const resetZoom = () => {
      zoomArea.classList.remove('is-zoomed');
      zoomButton.setAttribute('aria-pressed', 'false');
      zoomButton.textContent = 'Zoom in';
      zoomArea.scrollTop = zoomArea.scrollLeft = 0;
    };
    const syncDialog = () => {
      const frame = frames[index];
      fullImage.src = frame.src;
      fullImage.alt = frame.alt;
      fullImage.width = fullImage.height = frame.width;
      $('[data-gallery-dialog-title]').textContent = frame.label;
      $('[data-gallery-dialog-count]').textContent = `${index + 1} / ${frames.length}`;
      resetZoom();
    };
    const show = (nextIndex, revealThumb = false) => {
      index = (nextIndex + frames.length) % frames.length;
      const frame = frames[index];
      mainImage.srcset = `${frame.small} 480w, ${frame.medium} 960w, ${frame.src} ${frame.width}w`;
      mainImage.src = frame.src;
      mainImage.alt = frame.alt;
      mainImage.width = mainImage.height = frame.width;
      openLink.href = frame.src;
      openLink.setAttribute('aria-label', `Enlarge image ${index + 1}: ${frame.label}`);
      $('[data-gallery-caption]').textContent = frame.caption;
      const source = $('[data-gallery-source]');
      source.hidden = !frame.source;
      if (frame.source) source.href = frame.source;
      $('[data-gallery-status]').textContent = `${index + 1} / ${frames.length} · ${frame.label}`;
      thumbnails.forEach((button, i) => {
        if (i === index) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
        button.querySelector('img').src = frames[i].thumb;
        button.querySelector('span').textContent = frames[i].label;
        button.setAttribute('aria-label', `Image ${i + 1}: ${frames[i].label}`);
      });
      if (revealThumb) {
        const button = thumbnails[index];
        const left = button.offsetLeft - strip.offsetLeft;
        if (left < strip.scrollLeft) strip.scrollLeft = left;
        else if (left + button.offsetWidth > strip.scrollLeft + strip.clientWidth) strip.scrollLeft = left + button.offsetWidth - strip.clientWidth;
      }
      if (dialog.open) syncDialog();
    };
    $$('[data-gallery-prev]').forEach(button => button.addEventListener('click', () => show(index - 1, true)));
    $$('[data-gallery-next]').forEach(button => button.addEventListener('click', () => show(index + 1, true)));
    thumbnails.forEach(button => button.addEventListener('click', () => show(Number(button.dataset.galleryIndex), true)));
    gallery.addEventListener('keydown', event => {
      if (event.altKey || event.ctrlKey || event.metaKey) return;
      const offsets = {ArrowLeft:-1, ArrowRight:1};
      if (event.key in offsets && !zoomArea.classList.contains('is-zoomed')) {
        event.preventDefault();
        show(index + offsets[event.key], true);
      }
    });
    openLink.addEventListener('touchstart', event => {
      if (event.touches.length === 1) touchStart = {x:event.touches[0].clientX, y:event.touches[0].clientY};
      else touchStart = null;
    }, {passive:true});
    openLink.addEventListener('touchend', event => {
      if (!touchStart || !event.changedTouches.length) return;
      const dx = event.changedTouches[0].clientX - touchStart.x;
      const dy = event.changedTouches[0].clientY - touchStart.y;
      touchStart = null;
      if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy) * 1.5) {
        ignoreOpen = true;
        show(index + (dx < 0 ? 1 : -1), true);
        setTimeout(() => { ignoreOpen = false; }, 400);
      }
    }, {passive:true});
    openLink.addEventListener('click', event => {
      if (ignoreOpen) { event.preventDefault(); return; }
      if (typeof dialog.showModal !== 'function' || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
      event.preventDefault();
      syncDialog();
      dialog.showModal();
    });
    $('[data-gallery-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
    dialog.addEventListener('close', () => { resetZoom(); openLink.focus({preventScroll:true}); });
    zoomButton.addEventListener('click', () => {
      const zoomed = zoomArea.classList.toggle('is-zoomed');
      zoomButton.setAttribute('aria-pressed', String(zoomed));
      zoomButton.textContent = zoomed ? 'Fit image' : 'Zoom in';
    });
    mainImage.addEventListener('error', () => { $('[data-gallery-status]').textContent = 'Image could not load. Choose another photo.'; });
    $('[data-gallery-controls]').hidden = false;
    strip.hidden = false;
    return key => {
      if (key === offerKey || !manifest[key]) return;
      offerKey = key;
      frames = manifest[key];
      show(0);
      strip.scrollLeft = 0;
    };
  };

  const initGifts = (root, contract, money) => {
    const section = root.querySelector('[data-gifts]');
    if (!section) return () => {};
    const gifts = [...section.querySelectorAll('[data-gift]')];
    const panels = [...section.querySelectorAll('[data-gift-panel]')];
    let activeGift;
    const showDetails = key => {
      activeGift = key;
      gifts.forEach(gift => gift.setAttribute('aria-expanded', String(gift.dataset.gift === key)));
      panels.forEach(panel => { panel.hidden = panel.dataset.giftPanel !== key; });
    };
    const closeDetails = () => {
      const trigger = gifts.find(gift => gift.dataset.gift === activeGift);
      showDetails(null);
      trigger?.focus({preventScroll:true});
    };
    gifts.forEach(gift => gift.addEventListener('click', () => showDetails(activeGift === gift.dataset.gift ? null : gift.dataset.gift)));
    section.querySelectorAll('[data-gift-close]').forEach(button => button.addEventListener('click', closeDetails));
    section.addEventListener('keydown', event => {
      if (event.key === 'Escape' && activeGift) { event.preventDefault(); closeDetails(); }
    });
    section.querySelectorAll('[data-gift-select]').forEach(button => button.addEventListener('click', () => {
      const radio = [...root.querySelectorAll('input[type="radio"]')].find(input => input.value === button.dataset.qualifyingOffer);
      if (!radio || radio.disabled) return;
      radio.checked = true;
      radio.dispatchEvent(new Event('change', {bubbles:true}));
      gifts.find(gift => gift.dataset.gift === button.dataset.giftSelect)?.focus({preventScroll:true});
    }));
    return (offer, {paidJournal = false, busy = false, animate = false} = {}) => {
      let count = 0;
      const journalInSet = offer.books.some(key => key.trim() === 'journal');
      gifts.forEach(gift => {
        const type = gift.dataset.gift;
        const free = Boolean(offer[type]);
        const state = free ? 'unlocked' : type === 'journal' && journalInSet ? 'included' : type === 'journal' && paidJournal ? 'added' : 'locked';
        const previousState = gift.dataset.giftState;
        if (free) count += 1;
        gift.hidden = false;
        gift.dataset.giftState = state;
        gift.classList.toggle('is-unlocking', animate && state === 'unlocked' && previousState === 'locked');
        const badge = gift.querySelector('[data-gift-badge]');
        if (badge) badge.textContent = state === 'included' ? 'IN YOUR SET' : state === 'added' ? 'ADDED' : 'FREE';
        const qualifying = contract.offers.filter(item => item[type]).sort((a,b) => a.price - b.price)[0];
        const eligibility = state === 'unlocked' ? 'Free with your selected bundle.'
          : state === 'included' ? 'Already included as the seventh book in your collection. No extra journal is added.'
          : state === 'added' ? `Added to your pair for ${money(contract.journal.price)}.`
          : qualifying ? `Free with ${qualifying.name} (${money(qualifying.price)})${type !== 'journal' && type !== 'ebooks' ? ' and the larger sets' : type === 'ebooks' ? ' or the seven-book collection' : ''}.`
          : 'This gift is not included with your selection.';
        gift.setAttribute('aria-label', `${gift.dataset.giftName || type}. ${state === 'locked' ? 'Locked. ' : ''}${eligibility} View details.`);
        const panel = panels.find(item => item.dataset.giftPanel === type);
        if (panel) {
          panel.querySelector('[data-gift-eligibility]').textContent = eligibility;
          const select = panel.querySelector('[data-gift-select]');
          select.hidden = state !== 'locked' || !qualifying;
          select.disabled = busy;
          if (qualifying) {
            select.dataset.qualifyingOffer = qualifying.key;
            select.textContent = `${qualifying.available ? 'Select' : 'View'} ${qualifying.name} · ${money(qualifying.price)}`;
          }
        }
      });
      section.hidden = false;
      section.querySelector('[data-gift-count]').textContent = count ? `${count} free ${count === 1 ? 'gift' : 'gifts'} unlocked.${journalInSet && !offer.journal ? ' Journal included in your set.' : ''}` : 'Choose a bundle to unlock your gifts.';
      section.querySelector('[data-gift-detail]').textContent = offer.giftDetail || '';
    };
  };

  const init = (root) => {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const $ = (selector) => root.querySelector(selector);
    const $$ = (selector) => [...root.querySelectorAll(selector)];
    const contract = JSON.parse($('[data-dad-contract]').textContent);
    const offers = new Map(contract.offers.map(offer => [offer.key, offer]));
    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:contract.currency || 'USD',maximumFractionDigits:cents % 100 ? 2 : 0}).format(cents / 100);
    const form = $('.dad-form');
    const add = $('[data-dad-add]');
    const stickyAdd = $('[data-sticky-add]');
    const feedback = $('[data-cart-feedback]');
    const addon = $('[data-journal-checkbox]');
    const sticky = $('[data-dad-sticky]');
    const syncGallery = initGallery(root);
    const syncGifts = initGifts(root, contract, money);
    let current;
    let busy = false;
    const validVariant = id => /^[1-9]\d*$/.test(String(id || ''));
    const journalAvailable = () => contract.journal?.available && validVariant(contract.journal.variantId) && contract.journal.price === 2800;
    const purchasable = offer => offer.available && validVariant(offer.variantId) && offer.actualPrice === offer.price &&
      (!offer.journal || (journalAvailable() && String(offer.giftVariantId) === String(contract.journal.variantId))) &&
      (!(addon?.checked && offer.key === 'parents_v1') || journalAvailable());
    const total = () => current.price + (addon?.checked && current.key === 'parents_v1' ? Number(addon.dataset.price) : 0);
    const contents = {
      dad_v1: '1 paperback: Dad Volume 1, the pregnancy & birth guide.',
      parents_v1: '2 paperbacks: Dad Volume 1 + Mom Volume 1. One pregnancy guide for each of you.',
      dad_v1_v3: '3 Dad guides: pregnancy, baby’s first year, and toddlers. Plus a free Dad journal.',
      dad_v1_v7: '7 paperbacks: six Dad guides covering pregnancy, the early years, raising sons and potty training, plus the Dad journal.'
    };
    function syncSticky() {
      if (!('IntersectionObserver' in window)) return;
      const purchase = add.getBoundingClientRect();
      const intro = $('.dad-intro')?.getBoundingClientRect();
      const purchaseVisible = purchase.bottom > 0 && purchase.top < window.innerHeight;
      sticky.hidden = purchaseVisible || (intro && intro.bottom > 0);
      const choosing = purchase.top >= window.innerHeight;
      sticky.dataset.mode = choosing ? 'choose' : 'add';
      stickyAdd.disabled = busy || (!choosing && !purchasable(current));
      stickyAdd.textContent = busy ? 'Adding…' : choosing ? 'Choose your books ↑' : purchasable(current) ? 'Add to cart →' : 'Unavailable';
    }

    function sync(animate = false) {
      const key = $('input[type="radio"]:checked')?.value;
      current = offers.get(key);
      if (!current) return;
      syncGallery?.(key);
      $$('[data-offer-photo]').forEach(photo => { photo.hidden = photo.dataset.offerPhoto !== key; });
      $('[data-path-title]').textContent = current.pathTitle;
      $('[data-path-preview]').replaceChildren(...current.pathSteps.map(text => { const li = document.createElement('li'); li.textContent = text.trim(); return li; }));
      $('[data-roadmap-offer]').textContent = current.name;
      if ($('[data-selection-name]')) $('[data-selection-name]').textContent = current.name;
      if ($('[data-selection-detail]')) $('[data-selection-detail]').textContent = contents[key];
      if ($('[data-sons-note]')) $('[data-sons-note]').hidden = key !== 'dad_v1_v7';
      $$('[data-select-offer]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.selectOffer === key)));
      $$('[data-book]').forEach(book => {
        const journalGift = current.journal && book.dataset.book === 'journal';
        const included = journalGift || current.books.map(id => id.trim()).includes(book.dataset.book);
        book.classList.toggle('is-included', included);
        book.hidden = !included;
        book.querySelector('[data-book-included]').textContent = journalGift ? 'Included as a gift' : included ? 'In your selection' : book.dataset.book === 'mom-v1' ? 'In the Dad + Mom pair' : 'In a larger collection';
      });
      if (addon) {
        $('[data-journal-addon]').hidden = key !== 'parents_v1';
        if (key !== 'parents_v1') addon.checked = false;
        addon.disabled = busy || !journalAvailable();
      }
      syncGifts(current, {paidJournal: Boolean(addon?.checked && key === 'parents_v1'), busy, animate});
      $('[data-variant-input]').value = current.variantId || '';
      const canBuy = purchasable(current);
      $$('input[type="radio"]').forEach(radio => { radio.disabled = busy; });
      add.disabled = !canBuy || busy;
      stickyAdd.disabled = !canBuy || busy;
      $('[data-cta-text]').textContent = busy ? 'Adding…' : canBuy ? 'Add to cart' : 'Currently unavailable';
      stickyAdd.textContent = busy ? 'Adding…' : canBuy ? 'Add to cart →' : 'Unavailable';
      $('[data-cta-price]').textContent = money(total());
      $('[data-sticky-price]').textContent = money(total());
      $('[data-sticky-name]').textContent = current.name;
      $('[data-shipping-note]').textContent = current.shipping ? 'Free US shipping included with your bundle.' : '$6.99 US shipping. Free on orders over $60.';
      syncSticky();
    }
    $$('input[type="radio"]').forEach(radio => radio.addEventListener('change', () => { feedback.textContent = ''; sync(true); }));
    addon?.addEventListener('change', () => sync());
    $$('[data-select-offer]').forEach(button => button.addEventListener('click', () => {
      if (busy) return;
      const radio = $$('input[type="radio"]').find(input => input.value === button.dataset.selectOffer);
      if (!radio) return;
      radio.checked = true;
      feedback.textContent = '';
      sync(true);
    }));
    stickyAdd.addEventListener('click', () => {
      if (sticky.dataset.mode === 'choose') $('.dad-buy').scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      else form.requestSubmit();
    });
    form.addEventListener('submit', async event => {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (busy || !purchasable(current)) return;
      const selected = current;
      const intendedTotal = total();
      const includeAddon = addon?.checked && selected.key === 'parents_v1';
      busy = true;
      feedback.textContent = '';
      sync();
      const properties = { 'Book selection': selected.name, '_ywr_offer': selected.key };
      if (selected.rocky) properties['Rocky'] = 'Guaranteed early access at launch';
      if (selected.new_books) properties['New books'] = 'Early access to upcoming releases';
      if (selected.ebooks) properties['Digital access'] = 'You Will Rock As a Dad! Volume 1 eBook';
      const items = [{id:selected.variantId,quantity:1,properties}];
      if (selected.journal) items.push({id:contract.journal.variantId,quantity:1,properties:{'_ywr_gift_for':selected.key}});
      if (includeAddon) items.push({id:contract.journal.variantId,quantity:1});
      try {
        const response = await fetch(`${root.dataset.rootUrl}cart/add.js`, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
        if (!response.ok) {
          const result = await response.json();
          const error = new Error(typeof result.description === 'string' ? result.description : 'These books could not be added.');
          error.confirmedRejection = response.status >= 400 && response.status < 500;
          throw error;
        }
        /* Native Shopify pixels handle checkout events; this local event contains no customer data. */
        root.dispatchEvent(new CustomEvent('ywr:offer-added',{bubbles:true,detail:{offer:selected.key,value:intendedTotal / 100,currency:contract.currency}}));
        window.location.assign(selected.discountCode ? `${root.dataset.rootUrl}discount/${encodeURIComponent(selected.discountCode)}?redirect=${encodeURIComponent(root.dataset.cartUrl)}` : root.dataset.cartUrl);
      } catch (error) {
        feedback.textContent = error.confirmedRejection ? `${error.message} ` : 'We couldn’t confirm the cart update. Check your cart before trying again. ';
        const cartLink = document.createElement('a');
        cartLink.href = root.dataset.cartUrl;
        cartLink.textContent = 'View cart';
        feedback.append(cartLink);
        feedback.scrollIntoView({block:'nearest',behavior:'auto'});
        busy = false;
        sync();
      }
    });
    sync();
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(syncSticky, {threshold:0});
      observer.observe(add);
      if ($('.dad-intro')) observer.observe($('.dad-intro'));
    }
  };
  document.querySelectorAll('[data-dad-page]').forEach(init);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-dad-page]').forEach(init));
})();
